import { Paper, Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import * as services from "./../../services/saleng";
import classes from "./css/products-list.module.css";
import SubjectIcon from "@mui/icons-material/Subject";
import ReceiptIcon from "@mui/icons-material/Receipt";

function formatNumber(number) {
  return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const Reports = () => {
  const [rows, setRows] = useState([]);

  const columns = [
    {
      field: "billNumber",
      headerName: "เลขบิล",
      flex: 1,
    },
    {
      field: "date",
      headerName: "วันที่",
      flex: 1,
    },
    {
      field: "branchName",
      headerName: "สาขา",
      flex: 1,
    },
    {
      field: "customerName",
      headerName: "ชื่อลูกค้า",
      flex: 1,
    },
    {
      field: "totalWeight",
      headerName: "น้ำหนักสุทธิ",
      type: "number",
      flex: 1,
    },
    {
      field: "totalAmount",
      headerName: "ราคาสุทธิ",
      type: "number",
      flex: 1,
    },
    {
      field: "description",
      headerName: "ข้อมูลเพิ่มเติม",
      flex: 0,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <SubjectIcon
            onClick={() => window.open("/reports/" + params.row.transactionId)}
          />
        );
      },
    },
    {
      field: "receipt",
      headerName: "ใบเสร็จ",
      flex: 0,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <ReceiptIcon
            onClick={() => window.open("/receipt/" + params.row.transactionId)}
          />
        );
      },
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      services
        .getBranchTransaction()
        .then((response) => {
          console.log("response : ", response);
          const transaction = response.data.data;
          console.log("transaction", transaction);
          const TransactionWithIndex = transaction.map((item, index) => {
            // แปลง ISO datetime เป็น Date object
            const date = new Date(item.createdAt);

            // คำนวณเวลาตาม Timezone ของเครื่อง
            const localDate = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            );

            // แปลงเป็นรูปแบบ YYYY-MM-DD HH:mm:ss
            const formattedDate = localDate
              .toISOString()
              .replace("T", " ")
              .split(".")[0];

            return {
              ...item,
              id: index + 1,
              TransactionId: item.transactionId,
              date: formattedDate, // วันที่ + เวลาเครื่อง
              branchName: item.branch.name,
              customerName: item.customerName,
              totalWeight: formatNumber(item.totalWeight),
              totalAmount: formatNumber(item.totalAmount),
              description: "",
            };
          });

          console.log("TransactionWithIndex : ", TransactionWithIndex);
          setRows(TransactionWithIndex);
        })
        .catch((error) => {
          console.log("error : ", error);
        });
    };

    fetchData();
  }, []);

  return (
      <Paper className={classes["products-container"]} elevation={5} >
        <p
          style={{ display: "flex", justifyContent: "center", margin: "10px" }}
        >
          หน้ารายการแสดงผลการซื้อ-ขาย
        </p>

        <Box
          sx={{
            height: 630,
            width: "100%",
            // bgcolor:'black'
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[5]}
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                textOverflow: "clip",
                whiteSpace: "break-spaces",
                lineHeight: 1.5,
              },
            }}
          />
        </Box>
      </Paper>
  );
};

export default Reports;
